import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const cryptoWalletRoutes: RouteRecordRaw[] = [
  {
    path: routes.WALLET_TOKEN_TRANSACTIONS,
    name: 'WALLET_TOKEN_TRANSACTIONS',
    component: () => import('./TokenTransactionsPage.vue'),
    meta: { requiresAuth: true, title: 'Token Transactions' },
  },
]
